import { update_window_type } from '../../redux/Slice/windowTypeSlice';
import {
  setHotspotBillboardEnabled,
  prepareHotspotsForDesignMode,
  syncHotspotDesignQuaternion,
} from '../../components/gridpagefunction/HotSpot';
import store from '../../redux/store';
import { sceneStateHelper } from '../ThreeJsUtils/SceneStateHelper';
import { disablePreviewPhysics } from '../Physics/PhysicsUtils';

const getHotspotList = () =>
  store.getState().assets_object?.sceneHotspots || [];

const applyHotspotBillboard = (enabled) => {
  const hotspotList = getHotspotList();
  hotspotList.forEach((hp) => {
    try {
      setHotspotBillboardEnabled(hp, enabled);
    } catch (_) {}
  });
};

/**
 * Same steps as TabContainer design tab click: restore preview state,
 * switch window type back to design, disable hotspot billboards.
 */
export function exitPreviewMode({
  dispatch,
  scene,
  currentWindowType,
}) {
  const currentScene = scene;
  if (!currentScene || currentWindowType === 'design') return;

  if (currentWindowType === 'preview') {
    // Stop physics before restoring so the sim loop cannot overwrite transforms.
    disablePreviewPhysics();

    // Stop face-camera before restore — preview billboard mutates quaternion each frame.
    prepareHotspotsForDesignMode(getHotspotList());

    if (sceneStateHelper.hasSavedStates()) {
      sceneStateHelper.restoreStates(currentScene);
      sceneStateHelper.clear();
    }

    // Re-sync design quaternions from restored scene state.
    getHotspotList().forEach((hp) => {
      try {
        syncHotspotDesignQuaternion(hp);
      } catch (_) {}
    });
  }

  dispatch(
    update_window_type({
      type: 'design',
      current_type: currentWindowType,
      scene: currentScene,
    })
  );

  if (currentWindowType === 'preview') {
    requestAnimationFrame(() => {
      applyHotspotBillboard(false);
    });
  }
}
